import React, { useState } from 'react';
import Switch from "react-bootstrap-switch";
import { useForm } from "react-hook-form";
import { CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";

const PersonalTitleFilters = (props) => {
    const [status, setStatus] = useState(null)

    const { register, handleSubmit, reset } = useForm();

    const onSubmit = (data, _) => {
        const dataFilter = { ...data };

        if(status != null)
            dataFilter.status = status;

        props.refreshFiltered(dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        reset();
    }

    return (
        <Form onSubmit={ handleSubmit(onSubmit) }>
            <CardBody>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Código</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder="Búsqueda por código"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Valor</Label>
                            <Input
                                type="text"
                                name="value"
                                placeholder="Búsqueda por valor"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="1">
                        <FormGroup>
                            <Label>Activo</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ (item, value) => setStatus( value ) }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

export default PersonalTitleFilters